import React from "react";
import { useDispatch } from "react-redux";

import { AppDispatch } from "../../../../../redux/store";
import { setFidelity } from "../../../../../redux/slices/fidelitySlice";

import {
    flattenFidelitiesFromShops,
    hasStateChanged,
    pickDefaultFidelity,
} from "../helpers";

type Deps = {
    selectedShopsRows: any[];
    selectedRowsFidelity: any;
    activeFidelity: any[];
    rowsShop: any[];
    localShop: string[];
    setSelectedFidelity: (v: any[]) => void;
    setIsStateChanged: (v: boolean) => void;
};

export function useAssociateModalEffects({
    selectedShopsRows,
    selectedRowsFidelity,
    activeFidelity,
    rowsShop,
    localShop,
    setSelectedFidelity,
    setIsStateChanged,
}: Deps) {
    const dispatch = useDispatch<AppDispatch>();

    React.useEffect(() => {
        const local = flattenFidelitiesFromShops(selectedShopsRows);
        setSelectedFidelity(local);
        setIsStateChanged(
            hasStateChanged(local, selectedRowsFidelity, activeFidelity)
        );
    }, [
        selectedShopsRows,
        selectedRowsFidelity,
        activeFidelity,
        setSelectedFidelity,
        setIsStateChanged,
    ]);

    React.useEffect(() => {
        if (rowsShop[0] !== undefined) {
            dispatch(setFidelity(pickDefaultFidelity(rowsShop, localShop)));
        }
    }, [rowsShop, localShop, dispatch]);
}
